<template>
    <b-modal
        id="defectgroupmodal"
        :title="formModal.title"
        @hidden="resetModal"
        size="lg"
        ok-only
    >
        <div class="d-flex justify-content-between align-items-center mb-3">
            <house-component-defect-group-form :is-edit="false" :modal-id="0" :component-id="component_id" @update-list="updateList"></house-component-defect-group-form>
        </div>

        <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center" v-for="group in groups" :key="group.id">
                <span>
                    {{ group.name }} ({{ group.defects_count }})
                    <span v-if="group.context_helper" class="d-block text-muted small">{{ group.context_helper }}</span>
                </span>
                <span class="pull-right d-flex align-items-center">
                    <a class="btn btn-warning btn-sm btn-circle mr-1" @click="manageDefects(group)" title="Manage Defects">
                        <i class="fa fa-bug"></i>
                    </a>
                    <house-component-defect-group-form :is-edit="true" :form-data="group" :component-id="component_id" @update-list="updateList" :modal-id="group.id"></house-component-defect-group-form>
                    <a class="btn btn-danger btn-sm btn-circle ml-1" @click="deleteThis(group.id)">
                        <i class="fa fa-trash"></i>
                    </a>
                </span>
            </b-list-group-item>
        </b-list-group>

        <house-component-defect ref="houseComponentDefect" @update-list="updateList"></house-component-defect>
    </b-modal>
</template>

<script>
export default {
    data(){
        return this.initData();
    },
    methods: {
        initData(){
            return {
                formModal: {
                    title: null
                },
                groups: [],
                component_id: null,
                component_name: null,
            }
        },
        async openModal(id, name){
            try {
                const { data } = await axios.get(route("admin.houses.components.groups.index", id));
                this.component_id = id;
                this.component_name = name;
                this.groups = data.data;
                this.formModal.title = name ? (name + ' — Defect Groups') : 'Defect Groups';
                this.$bvModal.show('defectgroupmodal');
            } catch (e) {
                console.log(e);
                this.$swal('Error!', '', 'error');
            }
        },
        async updateList(){
            try {
                const { data } = await axios.get(route("admin.houses.components.groups.index", this.component_id));
                this.groups = data.data;
            } catch (e) {
                console.log(e);
                this.$swal('Error!', '', 'error');
            }
        },
        resetModal(){
            this.groups = this.initData().groups;
        },
        manageDefects(group){
            this.$refs.houseComponentDefect.openModal(this.component_id, group.id, this.component_name, group.name);
        },
        async deleteThis(id){
             this.$swal({
                title: 'Are you sure?',
                text: "This will also delete all defects in this group. You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await axios.delete(route("admin.houses.components.groups.destroy", [this.component_id, id]));
                        this.$swal({
                            title: 'Deleted!',
                            text: 'Defect Group has been deleted.',
                            icon: 'success',
                            didClose: () => {
                                this.updateList();
                            }
                        })
                    } catch (e) {
                        console.log(e);
                    }
                }
            });
        }
    }
}
</script>
